
import { Component, Prop, Watch, Emit, FormComponentBase } from "@/lib";
@Component({ name: "hi-input" })
export default class HiInput extends FormComponentBase {
  @Prop({ type: String, required: true, default: "" }) value: string;
  @Prop({ type: String, default: "text" }) type: string; //类型  text、password、textarea、url、email、date、tel
  @Prop({ type: Number, default: 50 }) maxlength: number; //最大长度
  @Prop({ type: Number, default: 0 }) minlength: number; //最小长度
  @Prop({ type: String, default: "" }) icon: string; //图标
  @Prop({ type: [Boolean, Object], default: false }) autosize: boolean | any; //自适应内容高度，仅在 textarea 类型下有效，可传入对象，如 { minRows: 2, maxRows: 6 }
  @Prop({ type: String, default: "Validate.PleaseInput" }) placeholder: string; //placeholder
  @Prop({ type: Boolean, default: true }) clearable: boolean;
  @Prop({ type: Boolean, default: false }) readonly: boolean;
  @Prop({ type: String, default: "100" }) width: string; //input占formitem宽度百分比

  get showWordLimit() {
    return this.type === "textarea";
  }
  get append() {
    let state = false;
    if (this.type !== "textarea") state = this.$slots.append !== undefined;
    return state;
  }

  get prepend() {
    let state = false;
    if (this.type !== "textarea") state = this.$slots.prepend !== undefined;
    return state;
  }

  get appendButton() {
    return this.$slots.button !== undefined;
  }

  get inputWidthStyle() {
    if (this.appendButton) {
      let width = "70";
      if (this.width != "100") {
        width = this.width;
      }
      return "width:" + width + "%";
    }
    return "";
  }

  get buttonWidthStyle() {
    if (this.appendButton) {
      let width = "29";
      if (this.width != "100") {
        width = (99 - parseFloat(this.width)).toString();
      }
      return "width:" + width + "%;float:right;text-align:right";
    }
    return "";
  }

  @Emit("on-clear")
  clear() {}
}
